import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table'

export type ImportIssueRow = { line: number, value: string, reason: string }

type IProps = {
  issues: ImportIssueRow[]
  /** Ce qui identifie la ligne : l'e-mail, ou le pseudo (#271). */
  valueLabel: string
}

/** Lignes refusées d'un import, avant l'envoi comme après : même tableau, mêmes libellés. */
function ImportIssuesTable({ issues, valueLabel }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="max-h-56 overflow-y-auto rounded-md border">
      <Table aria-label={t('users.import.previewTable')}>
        <TableHeader>
          <TableRow>
            <TableHead>{t('import.report.line')}</TableHead>
            <TableHead>{valueLabel}</TableHead>
            <TableHead>{t('import.report.reason')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {issues.map(issue => (
            <TableRow key={`${issue.line}-${issue.value}`}>
              <TableCell>{issue.line}</TableCell>
              <TableCell>{issue.value}</TableCell>
              <TableCell className="text-error-text">{t(`import.error.${issue.reason}`)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default ImportIssuesTable
